<template>
  <v-card class="mx-auto" outlined>
    <v-container>
      <h3>Seleccione</h3>
      <v-data-table
        mobile-breakpoint="0"
        dense
        light
        fixed-header
        class="fondolista"
        :headers="headers"
        :items="benefs"
        :page.sync="pagina"
        item-key="id_afiliado"
      >
        <template v-slot:item.id_afiliado="{ item }">
          <v-btn
            v-if="Seleccionado && item.id_afiliado != Seleccionado.id_afiliado"
            icon
            x-small
          >
            <v-icon @click="seleccionar(item)">mdi-magnify</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.nro_afi="{ item }">
          <span :class="clase(item)">{{ item.nro_afi }}</span>
        </template>
        <template v-slot:item.parent="{ item }">
          <span :class="clase(item)">{{ item.parent }}</span>
        </template>
        <template v-slot:item.parentesco="{ item }">
          <span :class="clase(item)">{{ item.parentesco }}</span>
        </template>
        <template v-slot:item.cuil="{ item }">
          <span :class="clase(item)">{{ item.cuil }}</span>
        </template>
        <template v-slot:item.apellido_y_nombre="{ item }">
          <span :class="clase(item)">{{ item.apellido_y_nombre }}</span>
        </template>
        <template v-slot:item.id_provincia="{ item }" :class="clase(item)">
          <cboProvincia
            :class="clase(item)"
            :id_provincia="item.id_provincia"
            readonly
          ></cboProvincia>
        </template>
        <template v-slot:item.fecha_nacimiento="{ item }">
          <span :class="clase(item)">{{
            arreglarFecha(item.fecha_nacimiento)
          }}</span>
        </template>
        <template v-slot:item.edad="{ item }">
          <span :class="clase(item)">{{ item.edad }}</span>
        </template>
        <template v-slot:item.fecha_alta="{ item }">
          <span :class="clase(item)">{{ arreglarFecha(item.fecha_alta) }}</span>
        </template>
        <template v-slot:item.fecha_baja="{ item }">
          <span :class="clase(item)">{{ arreglarFecha(item.fecha_baja) }}</span>
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cboProvincia from "@/components/Provincias/Seleccionada";
import LUM from "@/lib/LUM.js";
import parentesco from "../../store/modules/parentesco";
export default {
  props: {
    titular: {
      type: Boolean,
      default: false,
    },
    grupo: {
      type: Boolean,
      default: false,
    },
    alta: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    cboProvincia,
  },
  data: function() {
    return {
      pagina: 1,
      headers: [
        {
          text: "Sel",
          value: "id_afiliado",
        },
        {
          text: "Nro.Afi",
          value: "nro_afi",
        },
        {
          text: "/",
          value: "parent",
        },
        {
          text: "parentesco",
          value: "parentesco",
        },
        {
          text: "Cuil",
          value: "cuil",
        },
        {
          text: "Nombre y Apellido",
          value: "apellido_y_nombre",
        },
        {
          text: "Fecha de nacimiento",
          value: "fecha_nacimiento",
        },
        {
          text: "Edad",
          value: "edad",
        },
        {
          text: "Fecha de alta",
          value: "fecha_alta",
        },
        {
          text: "Fecha de baja",
          value: "fecha_baja",
        },
        {
          text: "Provincia",
          value: "id_provincia",
        },
      ],
    };
  },
  computed: {
    ...mapState("beneficiarios", [
      "Lista",
      "Titulares",
      "GrupoFamiliar",
      "Seleccionado",
    ]),
    ...mapState("parentesco", { tipos: "Lista" }),
    benefs() {
      let ret = undefined;
      if (this.titular) {
        ret = this.Titulares;
      } else {
        if (this.grupo) {
          ret = this.GrupoFamiliar;
        } else {
          ret = this.Lista;
        }
      }
      // ret = ret.map((x) => ({
      //   ...x,
      //   parentesco:
      //     this.tipos.find((p) => p.id_parentesco == x.id_parentesco)
      //       .descripcion_parentesco | "",
      //   edad: LUM.edad(new Date(x.fecha_nacimiento.replace(/-/g, ","))),
      // }));

      for (let r of ret) {
        let par = this.tipos.find((p) => p.id_parentesco == r.id_parentesco);
        r.parentesco = "";
        if (par) r.parentesco = par.descripcion_parentesco;
      }

      return ret;
    },
  },
  methods: {
    ...mapActions("beneficiarios", ["select", "selectTitular"]),
    seleccionar(item) {
      if (this.titular) {
        this.selectTitular(item);
      } else {
        this.select(item);
      }
    },
    clase(item) {
      let ret = "";
      if (item.fecha_baja == undefined) {
        ret = "deAlta";
      } else {
        ret = "deBaja";
      }
      return ret;
    },
    arreglarFecha(fecha) {
      return LUM.dataStringToDDMMYYYY(fecha);
    },
  },
  mounted() {},
};
</script>

<style>
.deBaja {
  color: red;
}
.deAlta {
  color: green;
}
.confondo {
  background-color: hotpink;
}
</style>
